import html2canvas from "html2canvas";
import { QRCodeCanvas } from "qrcode.react";
import { AiOutlineClose, AiOutlinePrinter } from "react-icons/ai";



const PrintQrCodeModalPromo = ({ isOpen, onClose, row }) => {
  // Convert mm to pixels (assuming 96 DPI: 1mm ≈ 3.779527559 pixels)
  const mmToPx = (mm) => mm * 3.779527559;

  // Print function for the QR code and its labels
  const QrCodePrint = async () => {
    const qrContainer = document.getElementById("qrDownloadContainer");

    if (!qrContainer) {
      console.error("QR Container not found");
      return;
    }

    try {
      const canvas = await html2canvas(qrContainer, {
        scale: 3,
        width: mmToPx(50), // Convert 50mm to pixels
        height: mmToPx(30), // Convert 30mm to pixels
        useCORS: true,
        logging: true,
        allowTaint: true,
      });

      const dataUrl = canvas.toDataURL("image/png");

      if (dataUrl) {
        // Create a new window for printing
        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
                    <html>
                        <head>
                            <title>Print Ticket</title>
                            <style>
                                @page { 
                                    size: 50mm 30mm; 
                                    margin: 0mm; 
                                }
                                body { 
                                    margin: 0; 
                                    padding: 0; 
                                    width: 50mm; 
                                    height: 30mm; 
                                }
                                img { 
                                    width: 50mm; 
                                    height: 30mm; 
                                    object-fit: contain;
                                }
                            </style>
                        </head>
                        <body>
                            <img src="${dataUrl}" onload="window.print();window.close()" />
                        </body>
                    </html>
                `);
        printWindow.document.close();
      }
    } catch (error) {
      console.error("Error generating QR code image:", error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "240px" }} role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Ticket</h5>
            <button className="btn btn-light rounded-circle border-0" onClick={onClose}>
              <AiOutlineClose color="black" />
            </button>
          </div>
          <div className="modal-body">
            <div
              id="qrDownloadContainer"
              className="d-flex flex-row align-items-center justify-content-between my-3"
              style={{
                width: `${mmToPx(50)}px`, // 50mm in pixels
                height: `${mmToPx(30)}px`, // 30mm in pixels
                padding: "2px",
                border: "1px solid #ddd",
                borderRadius: "5px",
                fontSize: "8px",
                lineHeight: "1.2",
                boxSizing: "border-box",
              }}
            >
              {/* Left Section: Text Info */}
              <div style={{
                flex: "1",
                textAlign: "left",
                paddingRight: "2px",
                overflow: "hidden",
                wordBreak: "break-word"
              }}>
                <div><strong>Code article:</strong> {row?.product?.productCode}</div>
                {/* <div><strong>Code à barres:</strong> {row?.product?.barcode}</div> */}

{/* {
  row?.initial_selling_price&& (
<div>
                    <strong>Prix initial:</strong>
 <div style={{
                      fontSize: "15px",
                      opacity: row?.initial_selling_price ? 0.7 : 1
                    }}>
                      <strong>{(typeof row?.initial_selling_price === 'number' ? row?.initial_selling_price : 0).toFixed(3)} DNT </strong>
                        
                    </div>
                    </div>
  )
} */}
                {row?.priceSale && (
                  <div>
                    <strong>Prix initial:</strong>
                    <div style={{
                      fontSize: "15px",
                      opacity: row?.priceSaleAfterPromo ? 0.7 : 1
                    }}>
                      <strong>{(typeof row?.priceSale === 'number' ? row?.priceSale : 0).toFixed(3)} DNT </strong>
                        
                    </div>
                     {/* <div style={{
                      fontSize: "15px",
                      opacity: row?.initial_selling_price ? 0.7 : 1
                    }}>
                      <strong>{(typeof row?.initial_selling_price === 'number' ? row?.initial_selling_price : 0).toFixed(3)} DNT </strong>
                        
                    </div> */}
                     {row?.promoPercent && <div style={{
                  fontSize: "10px"
                }}>{(typeof row?.promoPercent === 'number' ?"-" + row?.promoPercent : 0)} %</div>}
                  </div>
                )}
                {row?.priceSaleAfterPromo && <div><strong>Prix après remise:</strong> <div style={{
                  fontSize: "15px"
                }}><strong>{(typeof row?.priceSaleAfterPromo === 'number' ?  row?.priceSaleAfterPromo : 0).toFixed(3)} DNT</strong></div></div>}

             


              </div>

              {/* Right Section: QR Code */}
              {/* <div style={{ flex: "0 0 40px", textAlign: "center", paddingRight: "1px" }}>
                <QRCodeCanvas
                  value={row?.product?.barcode}
                  size={40} // Reduced size to fit in small ticket
                  bgColor={"#ffffff"}
                  fgColor={"#0a75ad"}
                  level={"H"}
                  imageSettings={{
                    src: "/noryx-icon.png",
                    height: 20,
                    width: 20,
                    excavate: true,
                  }}
                />
              </div> */}
            </div>
          </div>

          <div className="mb-3 d-flex gap-2 mx-3">
            <button
              onClick={QrCodePrint}
              className="btn btn-success d-flex justify-content-center align-items-center gap-3 w-100 mt-4"
            >
              <AiOutlinePrinter /> Print Ticket
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PrintQrCodeModalPromo;